import * as React from 'react';
import * as moment from "moment";
import 'moment/locale/it';
import 'moment/locale/en-gb';
import 'moment/locale/fr';
import 'moment/locale/es';
import 'moment/locale/de';
import { _ } from "@src/services/i18n";
import { classNames, css, mixin, vars, defaultProps } from '@src/services/theme';
import { bindToApp, alerts } from "services/api";
import { Modal } from '@src/components';
import { resolve } from 'path';

interface Notification {
  type: "success" | "error" | "warning",
  text: string
}

interface Props {
  locale?: string;
}

interface State {
  notification?: Notification | null
  notificationActive?: boolean;
  confirm?: string;
  alerts?:string;
}

const notificationStyle = css`
  position: fixed;
  z-index: 1000;
  left: 0;
  width: 100%;
  color: #fff;
  background: ${vars.colors.green};
  text-align: center;
  opacity: 0;
  transition: bottom ease-in-out 1s, opacity ease-in-out 1s;

  > div {
      padding: 45px 0;
  }

  & {
      bottom: -50px;
  }
  &.active {
      bottom: 0;
      opacity: 1;
  }
  &.warning {
      background-color: ${vars.colors.orange};
  }
  &.error {
      background-color: ${vars.colors.red};
  }
`;

const confirmStyle = css`
  .modal-backdrop {
    z-index: 1050;
  }
  .modal-dialog {
    ${mixin.center}  
    width: 300px;
    margin: 0;
  }
  .modal-header {
    display: none;
  }
  p {
    padding-bottom: 20px;
  }
  footer {
    display: flex;
    width: 100;
    justify-content: space-between;
  }
`;

var timers = {} as any;
var confirmPromise = {} as any;
class App extends React.Component<Props, State> {
  state = {} as State;
  
  constructor(props) {
    super(props);
//    moment.locale( props.locale );
    moment.locale( 'it' );
    bindToApp(this);
  }
  
  gotHttpError( error ) {
    var msg = error.toString()
    try {
      msg = error.response.data.message
    } catch(e) {}
    this.notificationPut({
        type: 'error',
        text: msg
    });
  }

  notificationPut( notification ) {
    this.setState({
      notification
    });
    setTimeout( () => {
      this.setState( { notificationActive: true } );
    }, 1 );
    if (timers && timers.close) {
      clearTimeout(timers.close);
    }
    timers.close = setTimeout( () => {
      this.notificationShut();
    }, 3000 );
  }
  
  notificationShut() {
    this.setState( { notificationActive: false } );
    setTimeout( () => {
      this.setState({
        notification: null
      });
    }, 300 );
  }

  confirmPut( question ) {
    this.setState({
      confirm: question
    });

    return new Promise( (resolve, reject) => {
      confirmPromise.resolve = resolve;
      confirmPromise.reject = reject;
    } );
  }
  
 alertsPut(question){
   this.setState({
     alerts:question
   });

   return new Promise((resolve)=>{
     confirmPromise.resolve=resolve;
   });


 }

 alertsDone( ){
  confirmPromise.reject();
  this.setState({alerts:undefined});
 }
  confirmDone( ) {
    confirmPromise.resolve();
    this.setState({confirm: undefined});
  }
  confirmCancel( ) {
    confirmPromise.reject();
    this.setState({confirm: undefined});
  }

  public render() {
    const { children } = this.props;
    const { notification, notificationActive, confirm, alerts } = this.state;
    
    return (
      <>
        {children}
        {notification &&
        <article className={classNames(notificationStyle, notificationActive ? 'active' : null, notification.type || 'success')} onClick={() => this.notificationShut()}>
          <div>
          { notification.text }
          </div>
        </article>
        }
        {alerts &&
          <Modal
          className={confirmStyle}
          title={alerts}
          open={true}
          onClose={() => this.alertsDone()}
        >
          <p>{alerts}</p>
          <footer>
            <button type="button" className="btn btn-primary" onClick={() => this.alertsDone()}>{_('Ok')}</button>
          </footer>
        </Modal>
        }
        {confirm &&
        <Modal
          className={confirmStyle}
          title={confirm}
          open={true}
          onClose={() => this.confirmCancel()}
        >
          <p>{confirm}</p>
          <footer>
            <button type="button" className="btn btn-secondary" onClick={() => this.confirmCancel()}>{_('confirm_ko')}</button>
            <button type="button" className="btn btn-primary" onClick={() => this.confirmDone()}>{_('confirm_ok')}</button>
          </footer>
        </Modal>
        }
      </>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App.tsx